import React from 'react'
import { classNames } from '../../utils'

interface ResourceSidebarProps {
  children: React.ReactNode
  rowStart?: string
}

export const ResourceSidebar = ({
  children,
  rowStart,
}: ResourceSidebarProps): JSX.Element => (
  <div
    className={classNames(
      rowStart,
      'col-span-12 flex flex-col divide-y divide-default-850 md:col-span-2 md:row-start-auto'
    )}
  >
    {children}
  </div>
)
